import { ConfirmationActions } from "@/constants";
import { useDisclosure } from "@/hooks";
import { useAcceptRejectRegistrationPendingMeditators, useConfirmRejectCancellationRequest } from "@/hooks/query-hooks/useMeditators";
import { Button, Modal } from "antd";
import { AiOutlineDelete } from "react-icons/ai";

export function RejectRegistrantModal({
    registrantId,
    onToggleDrawer,
    modalType
}: {
    registrantId: number;
    onToggleDrawer: () => void;
    modalType: "registration_pending" | "cancellation_pending";
}) {

    const [opened, { toggle }] = useDisclosure(false);

    const { mutate: rejectPendingRegistration, isLoading: isLoadingRegistration } = useAcceptRejectRegistrationPendingMeditators();

    const { mutate: rejectPendingCancellation, isLoading: isLoadingCancellation } = useConfirmRejectCancellationRequest();

    const onDelete = () => {
        const payload = {
            ids: [registrantId],
            action: ConfirmationActions.REJECT
        };

        switch (modalType) {
            case "registration_pending":
                rejectPendingRegistration(payload, {
                    onSuccess: () => {
                        toggle();
                        onToggleDrawer();
                    }
                });
                break;
            case "cancellation_pending":
                rejectPendingCancellation(payload, {
                    onSuccess: () => {
                        toggle();
                        onToggleDrawer();
                    }
                });
                break;
        }
    }

    return (
        <>
            <Button
                type="primary"
                size="large"
                shape="round"
                danger
                icon={<AiOutlineDelete size={18} />}
                onClick={toggle}
            >
                Reject
            </Button>
            <Modal
                open={opened}
                onCancel={toggle}
                onOk={onDelete}
                title={`Reject ${modalType === "registration_pending" ? "Registration" : "Cancellation"} Request`}
                okText="Reject"
                cancelText="Cancel"
                okButtonProps={{
                    size: "large",
                    danger: true,
                    loading: isLoadingCancellation || isLoadingRegistration,
                }}
                cancelButtonProps={{
                    size: "large",
                    type: "text",
                    disabled: isLoadingCancellation || isLoadingRegistration,
                }}
                centered
                width={400}
                classNames={{
                    header: "font-poppins [&>.ant-modal-title]:!text-lg [&>.ant-modal-title]:!font-medium",

                }}
            >
                <p
                    className=" text-danger  font-poppins py-2"
                >
                    Are you sure you want to reject this {modalType === "registration_pending" ? "registration" : "cancellation"} request? This action cannot be undone.
                </p>
            </Modal >
        </>
    )
}
